import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CPF from 'gerador-validador-cpf';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ParticipantsActions } from 'store/ducks/participants';

import { Validate } from 'common';
import { Page, Panel, Button, Loading } from 'components';
import { Form } from 'pages/Admin/Participants/components';

class Create extends Component {
  state = {
    data: {
      name: '',
      email: '',
      locale: { value: 'pt-BR', label: 'Português' },
    },
    errors: {},
  };

  handleChange = data => {
    this.handleValidate();
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      name: {
        required: true,
      },

      email: {
        required: true,
        email: true,
      },

      locale: {
        required: true
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    this.props.createParticipantRequest({
      person: {
        name: data.name,
        username: data.email,
        email: data.email,
        locale: data.locale.value,
      },
    });
  };

  render() {
    const { data, errors } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Novo Participante</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Button type="success" onClick={this.handleSubmit} disabled={create.loading}>
              {create.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Button>

            <Link to="/admin/participants" className="btn btn-danger m-l-10">
              Cancelar
            </Link>
          </div>
        </div>

        <Panel>
          <Form data={data} errors={errors} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.participants.create,
});

const mapActions = dispatch => bindActionCreators(ParticipantsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);



// WEBPACK FOOTER //
// ./src/pages/Admin/Participants/Create/index.js